var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSofiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A2C7;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.3,399.1c-0.8-7.7-4-13.6-9.8-17.9c-5.8-4.3-13.6-6.4-23.5-6.4c-6.7,0-12.4,0.9-17,2.8 c-4.6,1.9-8.2,4.5-10.6,7.8c-2.4,3.3-3.7,7-3.7,11.2c-0.1,3.5,0.6,6.5,2.2,9.1c1.6,2.6,3.9,4.8,6.7,6.7c2.9,1.9,6.2,3.5,9.9,4.9 c3.7,1.4,7.7,2.5,12,3.5l17.5,4.2c8.5,1.9,16.3,4.4,23.4,7.6c7.1,3.2,13.3,7.1,18.5,11.7c5.2,4.6,9.3,10.1,12.1,16.4 s4.4,13.5,4.4,21.6c-0.1,11.9-3.1,22.3-9.1,31c-6,8.7-14.6,15.5-25.9,20.3s-24.8,7.2-40.7,7.2c-15.7,0-29.4-2.4-41.1-7.2 c-11.7-4.8-20.7-12-27.2-21.5c-6.5-9.5-9.9-21.3-10.2-35.3h39.9c0.4,6.5,2.3,12,5.7,16.3c3.3,4.3,7.8,7.6,13.4,9.8s12,3.3,19.1,3.3 c7,0,13.1-1,18.2-3c5.2-2,9.2-4.9,12-8.5c2.9-3.6,4.3-7.8,4.3-12.5c0-4.4-1.3-8.1-3.9-11c-2.6-3-6.3-5.5-11.2-7.6 c-4.9-2.1-10.9-4-18-5.7l-21.2-5.3c-16.4-4-29.4-10.3-39-18.8s-14.3-20-14.2-34.4c-0.1-11.8,3.1-22.1,9.5-31 c6.4-8.8,15.2-15.7,26.3-20.7c11.2-5,23.9-7.4,38.1-7.4c14.5,0,27.1,2.5,38,7.4c10.8,5,19.3,11.8,25.3,20.7c6,8.8,9.1,19,9.3,30.7 H272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.7,440.6c0,21.3-4,39.4-12,54.3c-8,14.9-19,26.3-32.8,34.1c-13.8,7.8-29.3,11.8-46.5,11.8 c-17.3,0-32.9-3.9-46.7-11.8c-13.8-7.9-24.7-19.3-32.7-34.2c-8-14.9-12-33-12-54.2c0-21.3,4-39.4,12-54.3 c8-14.9,18.9-26.3,32.7-34.1c13.8-7.8,29.3-11.8,46.7-11.8c17.2,0,32.7,3.9,46.5,11.8c13.8,7.8,24.7,19.2,32.8,34.1 C507.7,401.2,511.7,419.3,511.7,440.6z M469.9,440.6c0-13.8-2-25.4-6.1-34.9c-4.1-9.5-9.9-16.6-17.3-21.5 c-7.4-4.9-16.1-7.3-26.1-7.3c-10,0-18.7,2.4-26.1,7.3c-7.4,4.9-13.2,12.1-17.3,21.5c-4.1,9.5-6.1,21.1-6.1,34.9 c0,13.8,2,25.4,6.1,34.9c4.1,9.5,9.9,16.6,17.3,21.5c7.4,4.9,16.1,7.3,26.1,7.3c10,0,18.7-2.4,26.1-7.3 c7.4-4.9,13.2-12.1,17.3-21.5C467.9,466,469.9,454.3,469.9,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.5,538.1V343h129.1v34h-87.9v46.5h79.3v34h-79.3v80.6H532.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M721,343v195h-41.2V343H721z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofiIcon);
export default __webpack_public_path__ + "static/media/sofi_icon.c6e777a4e0f6b1479cadef5450864c54.svg";
export { ForwardRef as ReactComponent };